<template>
<!-- <div class="row px-2">
    <h6>
      <span v-if="usesQ4">{{
              buildTitle()
          }}</span><span v-else>
            {{ question.title }}
          </span>
    </h6> <div @mouseenter="openTooltip" @mouseleave="closeTooltip"  :style="{width:20+'px',height:20+'px',cursor: 'default'}" class="ml-1 rounded-circle text-center align-top bgnscblue small infohover"><b> ? </b></div>
  </div><span  :id='avg' :style="{position:'fixed',zindex:99,maxWidth:350+'px'}" class='border rounded bgnscblue p-2 small transit' >{{tooltip[0]}}<br><br>{{tooltip[1]}}</span> -->
  <div class="row px-2 d-flex flex-row">
    <div class="" :style="{maxWidth:'900px'}">
      <h6>
      <span v-if="usesQ4">{{
              buildTitle()
          }}</span><span v-else>
            {{ question.title }}
          </span>
    </h6>
    </div>
    
    <div class="">
    <div @mouseenter="openTooltip" @mouseleave="closeTooltip"  :style="{width:20+'px',height:20+'px',cursor: 'default',maxWidth:'800px'}" class="ml-1 rounded-circle text-center align-top bgnscblue small infohover"><b> ? </b></div>
    <span :id='avg' :style="{position:'fixed'}" class='border rounded bgnscblue p-2 small transit' >{{tooltip[0]}}<br><br>{{tooltip[1]}}</span>
    </div>
  </div>
  <div class="row justify-content-center">
    <div class="col-3"></div>
    <div class="col-9">
    <apexchart width="900" type="bar" :options="options" :series="series"></apexchart>
    </div>
  </div>
</template>
  <script>
  import store from "../../store"
export default {
  props: ["benchmark", "question","tooltip", "avg"],
  data: function () {
    return {
      usesQ4: this.question.usesQ4 ? true : false,
      popover:false,
      options: {
        chart: {
          toolbar: {
              show: false,
            },
        },
        plotOptions: {
              bar: {
                
                horizontal: true,
              }
            },
        tooltip:{
          enabled:true,
          y:{
            formatter: (val)=>{
              let temp = (val / this.benchmark[1] *100).toFixed(0)

            return temp+'%'
            },
          },
          x:{
            show: false
          },
          marker:{
            show:false
          },
          // title: {
          //   formatter: (name) => { let temp = name;return 'Percent of total respondents' + temp}
          // }
        },
        responsive: [
          {
            breakpoint: 1000,
            options: {
              chart: {
                width: 300,
                height: 300,
                
              },
            }
          }
        ],
        dataLabels: {
          formatter: (val) => {
            let temp = (val / this.benchmark[1][0] *100).toFixed(0)

            return temp+'%'
          },
          style: {
            fontSize: '12px',
          }
        },
        grid: {
          show: false,
          borderColor: '#90A4AE',
            xaxis: {
              lines: {
                show: false
              },

            },
            yaxis: {
              lines: {
                show: false
              },

            }
          },
        xaxis: {
          categories: this.sortCategories(this.categoryTrim(this.question.responses),this.benchmark[0]),
          labels: {
            show:false,
            trim: true,
            rotate: -80,
            style: {
            fontSize: '12px',
          }
          },
          axisBorder: {
              show: false
          },
          axisTicks: {
          show: false,
          },
          style: {
            fontSize: '12px',
          }
        },
        yaxis: {
          labels: {
            show:true,
            trim: true,
            maxWidth: 160,
            align: "right",
            style: {
            fontSize: '12px',
          }
          },
          axisBorder: {
              show: false
          },
          max: this.makeSeries(this.benchmark[0])[0]+10//this.benchmark[1][0]
        },
        legend:{
          position:'top',
          show:true,
        },
        colors: this.benchmark[0].length > 9 ? ['#00843e'] : [  '#006bab']
      },
      
      test: this.makeSeries(this.benchmark[0]),
      series:[{
        name: 'Percent of total respondents',
        data: this.makeSeries(this.benchmark[0])
      }]
    }
  },
  methods: {
    openTooltip(event) {
      this.popover=true
      let x = event.clientX
      let y = event.clientY
      let tooltip = document.getElementById(`${this.avg}`)
      tooltip.classList.toggle('transit')
      // console.log(tooltip)
      tooltip.style.zIndex = 99
      tooltip.style.left = x+15+'px'
      tooltip.style.top = y+15+'px'
      
    },
    closeTooltip(){
      let tooltip = document.getElementById(`${this.avg}`)
      tooltip.classList.toggle('transit')
      
      
      this.popover=false
    },
    showModal(modal, data) {
      store.showModal(modal, data);
    },
    hideModal() {
      store.hideModal();
    },
    makeSeries(arr) {
        let modifedArr = this.question.ID === 14? arr.slice(0,12).concat(arr.slice(13)):arr.slice(0,7).concat(arr.slice(8))
        let temp = modifedArr.sort((x,y)=> {
          return y-x
        })
        temp.push(this.question.ID === 14?arr[12]:arr[7])
        // console.log(Object.values(temp))
        
         return temp//Object.values(temp)
      },
     categoryTrim(arr) {
      let temp = []
      for( let str of arr){
        let str2 = (str.lastIndexOf("(") > 0 ? str.slice(0,str.lastIndexOf("(")).trim() : str.lastIndexOf(",") > 0 ? str.slice(0,str.lastIndexOf(",")).trim() : str.lastIndexOf("?") > 0 ? str.slice(0,str.lastIndexOf("?")).trim() : str.trim())//.slice(0,31)
        temp.push(str2 ) //+ (str2.length>=31 ?'...':'')
      }
      
      return temp
    },
    chooseColors(int){

      return int < 4 ? ['#00843e'] : [  '#6dcff6'] //'#00843e','#006bab','#003a5c','#046938', '#72bf44',
    },
    buildTitle(){
      return `${this.question.title[0]} your company ${this.question.title[1]}`
    },
    sortCategories(cats,vals){
      let unsorted = vals.map(x=>x)
      let sorted = this.question.ID === 14? vals.slice(0,12).concat(vals.slice(13)):vals.slice(0,7).concat(vals.slice(8))//vals.map(x=>x)
      sorted.sort((x,y)=> {
          return y-x
        })
      sorted.push(this.question.ID === 14?vals[12]:vals[7])
      let temp = []
      for (let i = 0; i < cats.length; i++){
        let idx = unsorted.indexOf(sorted[i])
        
        if(temp.includes(cats[idx])){
         idx =  unsorted.indexOf(sorted[i], idx+1)
        }
        temp.push(cats[idx]) 
      }
      return temp
    }

     
  },
  
  setup() { },
};
</script>